import { ATTENDANCE_DISPLAY_TZ } from './attendanceTime';

/** Etiquetas y estilos para filas del tablero del día (`SupervisorTodayItem`). */

export const SUPERVISOR_TODAY_STATUS_LABEL = {
  present: 'Presente',
  late: 'Tarde',
  absent: 'Ausente',
  incomplete: 'Incompleto', // legacy API
  early_exit: 'Salida anticipada',
  scheduled: 'Pendiente',
  no_shift: 'Sin turno',
};

export const DAY_COMPLETION_LABEL = {
  complete: 'Completo',
  incomplete: 'Incompleto',
  in_progress: 'En curso',
  none: '—',
};

export function supervisorTodayStatusBadgeClass(status) {
  if (status === 'absent') return 'danger';
  if (status === 'late' || status === 'early_exit') return 'warning';
  if (status === 'present') return 'success';
  if (status === 'scheduled') return 'scheduled';
  return '';
}

export function dayCompletionBadgeClass(dayCompletion) {
  if (dayCompletion === 'complete') return 'success';
  if (dayCompletion === 'in_progress') return 'scheduled';
  if (dayCompletion === 'incomplete') return 'warning';
  return '';
}

function todayYmdInAttendanceTz() {
  return new Intl.DateTimeFormat('en-CA', {
    timeZone: ATTENDANCE_DISPLAY_TZ,
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  }).format(new Date());
}

/** Deriva jornada en cliente si el backend aún no envía day_completion. */
export function resolveDayCompletion(row, boardDateYmd) {
  if (row?.day_completion) return row.day_completion;
  if (!row?.check_in_time) return 'none';
  if (row.check_out_time) return 'complete';
  if (boardDateYmd >= todayYmdInAttendanceTz()) return 'in_progress';
  return 'incomplete';
}
